export default __webpack_public_path__ + "assets/0988b0af3eb801a80bddce3e228a4ef6.png";